import { searchPersonResults, PersonTeaser } from '@ltvco/refresh-lib/v1';

import { constants } from 'appConstants';
import {
  PersonTeaserFunctionArguments,
  TeaserResult,
} from 'components/ChatBV/types';

export const getPublicRecordsTeaser = async ({
  first_name,
  last_name,
  middle_name,
  age,
  state,
  city,
}: PersonTeaserFunctionArguments): Promise<TeaserResult> => {
  const data = await searchPersonResults(
    {
      searchPersonBy: 'name',
      options: {
        personSearchParams: {
          fName: first_name || '',
          lName: last_name || '',
          age: age?.toString() || '',
          mName: middle_name || '',
          city: city || '',
          state: state || '',
        },
        isOptout: false,
      },
    },
    constants.links.brandLink
  );
  const teaser = new PersonTeaser(data);
  return {
    teaserData: teaser.data || [],
    amountOfResults: teaser.data.length || 0,
  };
};
